import React from 'react';
import { connect } from 'react-redux';
import { isEmpty } from 'lodash';
import { NavItem, Button } from 'reactstrap';
import { parseSanitizedHTML, fireTealiumEvent } from '../../utils/Helper';

const MenuButtons = (props) => {
  const { siteConfig, i18n, type, className = '' } = props;
  const { data = {} } = siteConfig;
  const { menu_config = {} } = data[i18n.locale] || {};

  const triggerEvent = (tealiumData) => {
    fireTealiumEvent(tealiumData);
  };

  const generateButtonItems = (data) => {
    const ele = (v, k) => {
      if (type === 'HeaderTop') {
        const headerLinkProps = {
          href: v.url,
          target: '_blank',
          rel: 'noopener noreferrer',
          ...{
            onClick: () => triggerEvent(v.tealiumData),
          },
        };
        return (
          <div className={`${className} header-bar`}>
            <a {...headerLinkProps}>{parseSanitizedHTML(v.title)}</a>
          </div>
        );
      }

      if (type === 'MainMenu') {
        const MenuButtonProps = {
          color: 'primary',
          size: 'sm',
          href: v.url,
          ...{
            target: '_blank',
            rel: 'noopener noreferrer',
            onClick: () => triggerEvent(v.tealiumData),
          },
        };

        return (
          <NavItem className={`${className} menuButtons`}>
            <Button {...MenuButtonProps}>{parseSanitizedHTML(v.title)}</Button>
          </NavItem>
        );
      }
    };

    if (Array.isArray(data)) {
      return data.map((v, k) => {
        return ele(v, k);
      });
    }
    return ele(data, 0);
  };

  if (!isEmpty(menu_config) && menu_config.menu_buttons) {
    return <>{generateButtonItems(menu_config.menu_buttons)}</>;
  }
  return null;
};

const mapStateToProps = (state) => ({
  i18n: state.i18n,
  siteConfig: state.siteConfig,
});

const connectStore = connect(mapStateToProps, null, null, {
  pure: true,
})(MenuButtons);

export { MenuButtons as MenuButtonsComponent }; // <- For component Unit Test
export default connectStore;
